import { Namespace, TFunction } from "i18next"
import { DefaultError } from "../-components/error-context"

export function hasValidationErrors(e: DefaultError) {
  return e.status === 400 && e.validationErrors !== undefined
}

function camelize(str: string) {
  return str
    .split(".")
    .map((s) => s[0].toLowerCase() + s.slice(1))
    .join(".")
}

function translateServerValidationError(
  t: TFunction<Namespace, undefined>,
  v: string[]
) {
  // server can give any validation error
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return v.map((v) => t(v as any))
}

export function tryGetValidationErrorsAsMantineErrors(
  e: DefaultError,
  translateFn?: TFunction<Namespace, undefined>
) {
  const { validationErrors } = e
  if (validationErrors === undefined) {
    return undefined
  }
  const errors = Object.keys(validationErrors).reduce(
    (prev, curr) => ({
      ...prev,
      [camelize(curr)]: translateFn
        ? translateServerValidationError(translateFn, validationErrors[curr])
        : validationErrors[curr],
    }),
    {} as Record<string, string[]>
  )
  return errors
}
